import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './layout.scss';
import Navbar from './Navbar';
import { getSessionData } from 'utils.session';

const AppLayout = () => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }

  // Get actual current user from JWT (not localStorage.username which doesn't update on multi-login)
  const session = getSessionData();
  const storedUsername = localStorage.getItem('username') || '';
  const backUser = localStorage.getItem('backUser') || '';
  // If admin used multi-login to switch user, they are no longer admin
  const effectiveUsername = backUser ? '' : storedUsername;
  const userType = Number(session?.usertypeid) || 0;
  const userType1 = Number(session?.emisUsertype1) || 0;

  // Hide navbar on mail-request page for HR users, but show it for admin user (4028619)
  const hideNavbar =
    location.pathname === '/mail-request' && effectiveUsername !== '4028619';

  // HR-only users can only access /mail-request — redirect them from any other page
  const isMailRequestOnlyUser = userType === 21 && userType1 === 23;

  if (isMailRequestOnlyUser && location.pathname !== '/mail-request') {
    return <Navigate to="/mail-request" replace />;
  }

  return (
    <div className="app-layout">
      <Header />
      {!hideNavbar && <Navbar />}
      <main className="app-main container-fluid">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default AppLayout;
